import { FormControlProps } from '../../interfaces/FormControlProps';
import { InputState } from '../Input';
import { PropertyHelpers } from '../../helpers/PropertyHelpers';
import { FieldMaskHelpers } from '../../helpers/FieldMaskHelpers';

export class FormFieldStateHelpers {
    static getFieldState(component: React.Component<FormControlProps>) {
        let isTouchedOnlyWhenRequired: boolean = false;
        let visible: boolean = true;

        if (
            typeof component.props.formFieldDefinition.validation &&
            typeof component.props.formFieldDefinition.validation.required
        ) {
            isTouchedOnlyWhenRequired =
                component.props.form.touched[component.props.formFieldDefinition.name] === true &&
                component.props.field.value != null && component.props.field.value != '';
        }

        let readOnly: boolean = false;

        if (
            typeof component.props.formFieldDefinition.disabled &&
            component.props.formFieldDefinition.disabled == 'true'
        ) {
            if (
                component.props.formFieldDefinition.enabledOnError &&
                component.props.formFieldDefinition.enabledOnError === 'true' &&
                component.props.formikBag.values[
                    'error-' + component.props.formFieldDefinition.name
                ] &&
                component.props.formikBag.values[
                    'error-' + component.props.formFieldDefinition.name
                ]
            ) {
                readOnly = false;
            } else {
                readOnly = true;
            }
        }

        if (
            typeof component.props.formFieldDefinition.visibleOnError &&
            component.props.formFieldDefinition.visibleOnError == 'false'
        ) {
            if (                
                component.props.formikBag.values[
                    'error-' + (component.props.formFieldDefinition.fieldForErrorCheck || component.props.formFieldDefinition.name)
                ]
            ) {
                visible = false;
            }
        }

        if (
            typeof component.props.formFieldDefinition.visibleOnError &&
            component.props.formFieldDefinition.visibleOnError == 'true'
        ) {
            visible = false;
            if (                
                component.props.formikBag.values[
                    'error-' + (component.props.formFieldDefinition.fieldForErrorCheck || component.props.formFieldDefinition.name)
                ]
            ) {
                visible = true;
            }
        }

        return { isTouchedOnlyWhenRequired, readOnly, visible };
    }

    static hasErrors(component: React.Component<FormControlProps>) {
        const props = component.props;

        return props.form && props.form.errors[props.formFieldDefinition.name];
    }
    
    static hasErrorsByFieldName(component: React.Component<FormControlProps>,
        fieldName: string ) {
        const props = component.props;

        return props.form && props.form.errors[fieldName];
    }

    static isTouchedHasErrors(
        component: React.Component<FormControlProps>,
        fieldName: string = null
    ) {
        const props = component.props;
        // By default we take the props, but on override, we take given field name
        fieldName = fieldName || props.formFieldDefinition.name;
        return props.form && props.form.touched[fieldName] && props.form.errors[fieldName];
    }

    static canUpdateField(component: React.Component<FormControlProps>, inputValue: string) {
        if (PropertyHelpers.maskCharsExpression(component.props)) {
            // We have a masked value
            const { value, passTest } = FieldMaskHelpers.testMaskedValue(
                component as any,
                inputValue
            );

            // Action
            return value == '' || passTest;
        }
        return true;
    }
    static clearMarkedFields(component: React.Component<FormControlProps>) {
        if (component.props.formFieldDefinition.clearFields !== undefined) {
            component.props.formFieldDefinition.clearFields.map((fieldName: string) => {
                component.props.formikBag.setFieldValue(fieldName, '');
                component.props.formikBag.setFieldError(fieldName, '');
                component.props.formikBag.setFieldTouched(fieldName, false, false);
            });
        }
    }
    static updateFormikField(component: React.Component<FormControlProps, InputState>, value: any) {
        let newValue = value || '';

        if (!!component.props.formFieldDefinition.alwaysUppercase) {
            newValue = newValue.toUpperCase();
        }

        component.props.formikBag.setFieldTouched(component.props.formFieldDefinition.name, true, false);
        // By using .then, we have no need for a setTimeout before validating the value.
        component.props.formikBag.setFieldValue(component.props.formFieldDefinition.name, newValue, true).then((res) => {
            const error = component.props.formController.validateField(component.props.formFieldDefinition, component.props.formikBag);
            component.props.formikBag.setFieldError(component.props.formFieldDefinition.name, error);

            component.props.formikBag.validateForm(component.props.formikBag.values);
        });
    }
}
